import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { updateAssetName } from "../../app/slices/AssetsSlice";
import { AssetDetailsDTO } from "../../dto/AssetDTO";
import { UpdateAssetName } from "../../hooks/UpdateAssetNameHook";

/**
 * Renames an asset from wherever it is shown.
 *
 * Two dispatches, deliberately: `UpdateAssetName` writes the API and the
 * cached-asset copy, but the file explorer renders from
 * `assetsInCurrentFolder`, which it does not touch. Without the second one the
 * row keeps the old name until the folder is refetched.
 */
export const useRenameAsset = () => {
  const dispatch = useDispatch();
  const [updateAsset] = UpdateAssetName();

  return useCallback(
    (asset: AssetDetailsDTO, rawName: string) => {
      const name = rawName.trim();
      if (!name || name === asset.name) return;

      updateAsset(asset.id, name);
      dispatch(updateAssetName({ ...asset, name }));
    },
    [dispatch, updateAsset]
  );
};
